import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { renderElementExplanations } from './renderElementExplanations';
import { ExplanationsOptions } from './types';
import { ExplanationsReadOnlyPlugin } from './ExplanationsReadOnlyPlugin';

export const ExplanationsPlugin = (options?: ExplanationsOptions): SlatePlugin => {
  if (options.isReadOnly) {
    return ExplanationsReadOnlyPlugin(options);
  }
  return {
    renderElement: renderElementExplanations(options),
  };
};
